<template>
  <div class="page-wrap">
    <section>
      <div class="content special">
        <div class="params" v-loading="treeLoading">
          <template v-for="(subList, level) in allTypeList">
            <div class="param-item" v-if="level < maxLevel + 1" :key="level">
              <div class="item-l" v-if="level == 0">分类</div>
              <!-- <div class="item-l"
                v-if="level==1">类别</div> -->
              <div class="item-l" v-if="level == 1">学科</div>
              <ul class="item-r">
                <li
                  :class="{ current: activeArr[level] == index }"
                  v-for="(item, index) in subList"
                  :key="`type1_${index}`"
                  @click="createChildList(item, index, level)"
                >
                  {{ item.name }}
                </li>
              </ul>
            </div>
          </template>
          <!-- <div class="param-item">
            <div class="item-l">学科</div>
            <ul class="item-r">
              <li
                :class="{ current: activeArr[2] == index }"
                v-for="(item, index) in allTypeList[2]"
                :key="`type1_${index}`"
                @click="createChildList(item, index, 2)"
              >
                {{ item.name }}
              </li>
            </ul>
          </div> -->
          <div class="param-item">
            <div class="item-l">排序</div>
            <ul class="item-r">
              <li
                :class="{ current: sortActive == index }"
                v-for="(item, index) in sortList"
                :key="`sort_${index}`"
                @click="handleSort(item, index)"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
        </div>
        <div class="list" v-loading="loading">
          <ul v-if="list.length > 0">
            <li
              class=""
              @click="goDetail(item)"
              v-for="(item, index) in list"
              :key="index"
            >
              <div class="imgbox">
                <el-image :src="item.courseCoverFileUrl"></el-image>
                <div
                  class="status"
                  v-show="
                    item.importanceType != null && item.importanceType == 2
                  "
                >
                  重点
                </div>
              </div>
              <div class="infobox">
                <div class="title" v-ellipsis>{{ item.courseName }}</div>
                <div class="info">
                  <span>{{ item.createUserName }}</span>
                  <span>{{ item.createUserCollegeName }}</span>
                </div>
              </div>
            </li>
          </ul>
          <div class="nodata" v-else>暂无数据</div>
        </div>
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :page-size="form.size"
          :total="total"
          @current-change="pageChange"
        >
        </el-pagination>
      </div>
    </section>
  </div>
</template>
     
<script>
import moment from 'moment'
import eventBus from '@/utils/eventBus.js'
export default {
  components: {
  },
  data() {
    return {
      list: [],
      treeLoading: false,
      loading: false,
      form: {
        page: 1,
        size: 20,
        name: this.$route.query.searchContent || '',
        courseCategory: '',
        courseCategoryDetailId: '',
        sort: 1
      },
      total: 0,
      treeData: [],
      treeData1: [],
      treeData2: [],
      allTypeList: [
        [{ name: '虚仿课', id: 1 }, { name: '普通课', id: 2 }],
      ],
      activeArr: [],
      sortList: [{ name: '综合排序', id: 1 }, { name: '按选课人数', id: 2 }, { name: '按发布时间', id: 3 }],
      sortActive: 0,
      id: '',
      maxLevel: 1,//最大层级索引

    }
  },
  mounted() {
    this.getTreeData()
    eventBus.$on('handleSearch', (val) => {
      this.form.name = val
      this.getList()
    })
    if (this.form.name) {
      this.getList()
    }
  },
  destroyed() {
    eventBus.$off('handleSearch')
  },
  methods: {
    getTreeData() {
      this.treeLoading = true
      Promise.all([
        this.$api.courseManage.courseCategoryDetail({ courseCategoryId: 1 }),
        this.$api.courseManage.courseCategoryDetail({ courseCategoryId: 2 })
      ]).then(res => {
        this.treeData1 = res[0].data
        this.treeData2 = res[1].data
        this.allTypeList[0][0].children = this.treeData1
        this.allTypeList[0][1].children = this.treeData2
        //初始加载第一级第一个数据
        this.createChildList(this.allTypeList[0][0], 0, 0)
      }).finally(() => {
        this.treeLoading = false
      })
    },
    //获取下级数据
    /**
     * params:
     *  item: 当前点击的节点
     *  index: 当前点击的子节点的index
     *  level: 当前点击的节点的层级
     */
    createChildList(item, index, level) {
      this.activeArr[level] = index
      let lastChildIndex = this.activeArr[level + 1] ? this.activeArr[level + 1] : 0
      let lastChildId = this.allTypeList[level + 1] ? this.allTypeList[level + 1][lastChildIndex].id : ''
      this.allTypeList[level + 1] = [{ name: '全部', id: '' }]
      if (item.id == '') {
        this.allTypeList[level].forEach((el) => {
          if (el.children && el.children.length > 0) {
            el.children.forEach((child, k) => {
              this.allTypeList[level + 1].push(child)
            })
          }
        })
      } else {
        if (item.children && item.children.length > 0) {
          item.children.forEach((child) => {
            this.allTypeList[level + 1].push(child)
          })
        }
      }
      let newIndex = this.allTypeList[level + 1].findIndex((el) => el.id == lastChildId)
      this.activeArr[level + 1] = newIndex > -1 ? newIndex : 0
      let currentChildItem = this.allTypeList[level + 1][this.activeArr[level + 1]]
      //如果子集只有一个，则直接获取列表
      if (level < this.maxLevel) {
        this.createChildList(currentChildItem, this.activeArr[level + 1], level + 1)
      } else {
        if (this.allTypeList[level] && this.allTypeList.length > 3) this.allTypeList.splice(level + 1, 1)

        this.$forceUpdate()
        this.$nextTick(() => {
          this.getList()
        })
      }
    },
    handleSort(item, index) {
      this.sortActive = index
      this.$set(this.form, 'sort', item.id)
      this.getList()
    },
    getList() {
      this.loading = true
      this.$set(this.form, 'courseCategory', this.allTypeList[0][this.activeArr[0]].id)
      // 从第二项开始，取出数组中最后一个不为0的元素、索引(注意索引要取最后出现的位置)
      let lastActive = this.activeArr.filter((item, index) => index > 0 && item > 0 && index < this.maxLevel + 1).pop()
      let level = this.activeArr.lastIndexOf(lastActive)
      if (level > -1) {
        this.$set(this.form, 'courseCategoryDetailId', this.allTypeList[level][lastActive].id)
      } else {
        this.$set(this.form, 'courseCategoryDetailId', '')
      }
      this.$set(this.form, 'publishStatus', 1)
      this.$api.courseManage.getSearchList(this.form).then(res => {
        this.list = res.data.list
        this.total = res.data.total
      }).finally(() => {
        this.loading = false
      })
    },
    pageChange(index) {
      this.form.page = index
      this.getList(index)
    },
    //确定课程状态的
    stateFn(num) {
      const obj = {
        '0': require('@/assets/images/training/wcj.png'),
        '1': require('@/assets/images/training/wwc.png'),
        '3': require('@/assets/images/training/ywc.png')
      }
      return obj[num]
    },
    goDetail(val) {
      this.$router.push({
        path: '/portal/search/detail',
        query: {
          id: val.id
        }
      })
    },
    //格式化课程总时长 
    formatTime(s) {
      const time = moment.duration(s, 'seconds')  //得到一个对象，里面有对应的时分秒等时间对象值
      const hours = time.hours()
      const minutes = time.minutes()
      const seconds = time.seconds()
      return moment({ h: hours, m: minutes, s: seconds }).format('HH:mm:ss')
    },
  }
}
</script>

<style lang="scss" scoped>
.page-wrap {
  flex: 1;
}
section {
  height: 100%;
  // background: var(--content-background-color);
}
.special {
  height: 100%;
  margin: 0 auto;
  padding-top: 20px;
  padding-bottom: 60px;
  display: flex;
  flex-direction: column;
  .params {
    padding: 20px;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 4px;
    .param-item {
      display: flex;
      align-items: center;
      margin-top: 18px;
      &:nth-of-type(1) {
        margin-top: 0;
      }
      .item-l {
        min-width: 60px;
        font-weight: 700;
        font-size: 14px;
      }
      .item-r {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        > li {
          margin: 0 8px;
          padding: 0 16px;
          height: 28px;
          line-height: 28px;
          cursor: pointer;
          &:nth-of-type(1) {
            margin-left: 0;
          }
          &.current {
            color: $--color-primary;
            background-color: rgba(69, 134, 255, 0.08);
            border-radius: 4px;
          }
        }
      }
    }
  }
  .search-max {
    display: flex;
    justify-content: center;
    position: relative;
  }
  .el-input {
    width: 700px;
    height: 56px;
    margin: 40px 0;
    & > /deep/ .el-input__inner {
      width: 100%;
      height: 100%;
      border: none;
    }
    .el-button {
      width: 100px;
      height: 56px;
      background: var(--accent-color);
      border-radius: 0 4px 4px 0;
      border-radius: 0 4px 4px 0;
      font-family: PingFangSC-Medium;
      font-weight: 500;
      font-size: 16px;
      color: var(--white-color);
    }
  }
  .list {
    flex: 1;
    > ul {
      display: flex;
      flex-wrap: wrap;
      margin-top: 20px;
      width: calc(100% + 20px);
      margin-left: -10px;
      & > li {
        border-radius: 4px;
        overflow: hidden;
        width: calc(25% - 20px);
        margin: 0 10px 20px;
        box-shadow: 0 10px 20px 0 rgba(213, 221, 236, 0.4);
        cursor: pointer;
        .imgbox {
          width: 100%;
          height: 160px;
          position: relative;
          .el-image {
            width: 100%;
            height: 100%;
          }
          .status {
            width: 72px;
            height: 32px;
            line-height: 32px;
            text-align: center;
            color: #fff;
            font-size: 16px;
            background: #ea8303;
            box-shadow: inset 0 0 4px 1px #ffffff4d;
            border-radius: 0 4px 0 16px;
            position: absolute;
            top: 0;
            right: 0;
            z-index: 5;
          }
        }
        .infobox {
          width: 100%;
          height: 94px;
          background-color: #fff;
          padding: 12px 16px;
          .title {
            font-size: 16px;
            font-weight: bold;
            line-height: 24px;
          }
          .info {
            margin-top: 12px;
            font-size: 14px;
            line-height: 22px;
            color: #636b79;
            > span {
              padding: 0 10px;
              &:nth-of-type(1) {
                padding-left: 0;
                border-right: 1px solid #636b79;
              }
            }
          }
        }
        &:hover {
          .infobox {
            .title {
              color: $--color-primary;
            }
          }
        }
      }
    }
  }
  .el-pagination {
    text-align: center;
    margin-top: 20px;
  }
}
/deep/.el-pagination.is-background .btn-prev,
/deep/.el-pagination.is-background .btn-next,
/deep/.el-pagination.is-background .el-pager li {
  width: 32px;
  height: 32px;
  color: var(--text2-color);
  background-color: var(--white-color);
  border: 1px solid var(--dividing-line-color);
  &.active {
    background-color: $--color-primary;
  }
}
/deep/.el-pagination.is-background .el-pager li.more {
  background: none;
  border: none;
}
</style>


// WEBPACK FOOTER //
// src/views/portal/search.vue